import { CodyIcon } from '../components/CodyLogo';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <header className="bg-white border-b border-[#E6E8EE] sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-3">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-sm text-[#5B667A] hover:text-[#0B0F17]"><ArrowLeft className="w-4 h-4" /> Back</button>
          <div className="ml-auto"><CodyIcon size={28} /></div>
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-extrabold mb-2" style={{ fontFamily: "'Space Grotesk'" }}>Terms of Service</h1>
        <p className="text-sm text-[#5B667A] mb-8">Last updated: March 21, 2026</p>
        <div className="prose prose-sm max-w-none text-[#374151] space-y-6">
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>1. Acceptance of Terms</h2>
            <p>By accessing or using Cody ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>2. Description of Service</h2>
            <p>Cody is a Reddit lead discovery platform that helps businesses find potential customers by monitoring Reddit discussions, scoring posts for buyer intent, and generating AI-powered reply suggestions.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>3. Account Registration</h2>
            <p>You must provide accurate and complete information when creating an account. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>4. Subscription Plans and Billing</h2>
            <p>Cody offers free and paid subscription plans. Paid plans are billed monthly or annually as selected at the time of purchase. Prices are subject to change with 30 days' notice.</p>
            <p><strong>Free Plan (Startup):</strong> Limited to 1 business, 5 keywords, 5 subreddits, and 3 leads per day.</p>
            <p><strong>Paid Plans (Growth & Agency):</strong> Include expanded limits, AI reply generation, real-time scanning, and additional businesses.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>5. No Refund Policy</h2>
            <div className="bg-[#FFF8F5] border border-[#FF4500]/20 rounded-lg p-4">
              <p className="font-bold text-[#0B0F17]">All payments are final and non-refundable.</p>
              <p className="mt-2">Due to the nature of our digital service and the immediate access to AI-powered features and data upon payment, we do not offer refunds for any subscription payments, including but not limited to:</p>
              <ul className="list-disc pl-5 space-y-1 mt-2">
                <li>Monthly or annual subscription fees</li>
                <li>Additional brand add-on fees</li>
                <li>Partial month or unused period charges</li>
                <li>Downgrades from a higher-tier plan</li>
              </ul>
              <p className="mt-2">You may cancel your subscription at any time. Upon cancellation, you will continue to have access to your paid plan features until the end of your current billing period, after which your account will revert to the free plan.</p>
            </div>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>6. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Use the Service to spam, harass, or deceive Reddit users</li>
              <li>Violate Reddit's Terms of Service or community guidelines</li>
              <li>Use automated bots to post AI-generated replies without human review</li>
              <li>Attempt to circumvent plan limits or usage restrictions</li>
              <li>Reverse engineer, decompile, or attempt to extract the source code</li>
              <li>Use the Service for any unlawful purpose</li>
            </ul>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>7. AI-Generated Content</h2>
            <p>Reply suggestions generated by AI are provided as drafts only. You are solely responsible for reviewing, editing, and posting any content to Reddit. We do not guarantee the accuracy, appropriateness, or effectiveness of AI-generated replies.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>8. Limitation of Liability</h2>
            <p>The Service is provided "as is" without warranties of any kind. We shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service, including but not limited to loss of revenue, data, or business opportunities.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>9. Termination</h2>
            <p>We reserve the right to suspend or terminate your account at any time for violation of these Terms or for any other reason at our sole discretion. Upon termination, your right to use the Service will immediately cease.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>10. Changes to Terms</h2>
            <p>We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>11. Contact</h2>
            <p>For questions about these Terms, contact us at <a href="mailto:support@trycody.com" className="text-[#FF4500] hover:underline">support@trycody.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
